export default {
  datasetName: "数据名称",
  datasetCode: "数据标识",
  datasetSize: "文件大小",
  pattern: "文件后缀",
  detail: "数据描述",
  rows: "行数",
  cols: "列数",
  totalNulls: "总缺失值",
  NullProportion: "总缺失值占比",
  col_nulls: "列缺失值分布图",
  row_nulls: "行缺失值分布图",
  assessmentMethod: "验证程序",
  head: "前150字内容",
  mid: "中间300字内容",
  tail: "后150字内容",
  total: "总字数",
  word: "字",
  totalDuration: "视频总时长",
  positions: "抽取位置",
  description: "程序简介",
};
